import { useContext } from 'react';
import { ViewportContext } from './viewport.context';

export const useViewport = () => {
    const { width, height } = useContext(ViewportContext);
    return {
        width,
        height,
        // --from-tablet-landscape breakpoint
        isMobile: width < 1024,
    };
};

export default useViewport;
